import { Space , AHSeparator , AHText , TouchableBox , Box } from "arkh";




import { TeamSectionHeaderCTAButton } from "./TeamSectionHeaderCTAButton";

export function TodoCategorySectionHeader(props: {
  spaceHorizontal: Space;
  ctaPress?: () => void;
  ctaTitle?: React.ReactNode;
  notResolvedCount?: number;
  title: string;
  isLast?: boolean;
  icon: React.ReactNode;
}) {
  return (
    <Box
      spaceHorizontal={props.spaceHorizontal}
      color="surface-background"
      spaceTop="medium"
    >
      <TouchableBox
        color="surface-primary"
        cornerRadiusTopLeft="large"
        cornerRadiusTopRight="large"
        cornerRadiusBottomLeft={props.isLast ? "large" : "none"}
        cornerRadiusBottomRight={props.isLast ? "large" : "none"}
        borderColor="border-primary"
        space="medium"
        style={{
          flexDirection: "row",
          alignItems: "center",
          borderWidth: 1,
          margin: -1,
        }}
        disabled={!props.ctaPress}
        onPress={
          props.ctaPress
            ? () => {
                props.ctaPress?.();
              }
            : undefined
        }
      >
        {props.icon}
        {props.notResolvedCount !== undefined ? (
          <AHText
            type="title"
            spaceRight="small"
            spaceLeft="small"
            color={
              props.notResolvedCount > 0 ? "text-primary" : "text-secondary"
            }
          >
            {props.notResolvedCount}
          </AHText>
        ) : null}
        <AHText type="subtitle" color="text-secondary" style={{ flex: 1 }}>
          {props.title}
        </AHText>
        {props.ctaTitle && props.ctaPress ? (
          <TeamSectionHeaderCTAButton ctaTitle={props.ctaTitle} />
        ) : null}
      </TouchableBox>
      <AHSeparator />
    </Box>
  );
}
